/**
 * HeroImageSectionFront.jsx
 * Created by Destin Frasier on 08/13/18.
 * Updated on 05/22/19
 */

import React from 'react';
import PropTypes from 'prop-types';

import Heading from './../sharedComponents/Heading';
import Button from './../sharedComponents/Button';
import Select from './../sharedComponents/Select';

export default class HeroImageSectionFront extends React.PureComponent {
    static propTypes = {
        /** Title of the page/hero image */
        title: PropTypes.string,

        /** Text that appears under the hero title */
        text: PropTypes.string,

        /** If true, the header and subhead will be black */
        hasDarkText: PropTypes.bool,

        /** If true, a button will be added to the hero section */
        hasButton: PropTypes.bool,

        /** If true, the button will automatically scroll to a specific anchor on the page.  */
        isScroll: PropTypes.bool,

        /** Sets the style/appearance for the button. */
        buttonAppearance: PropTypes.oneOf([
            'primary',
            'secondary',
            'tertiary',
            'tertiary-alt',
            'tertiary-white',
            'solid-white',
            'subtle',
            'link',
            'danger',
            'subtle-danger',
            'pill'
        ]),

        /** Text that appears within the button */
        buttonText: PropTypes.string,

        /** URL or ID for a specific place on the same page. (If this is a ID, make sure that "isScroll" is set to true)  */
        buttonLink: PropTypes.string,

        /** Added to existing classes */
        className: PropTypes.string,

        /** Set the landmark or html tag for the component */
        semanticElementName: PropTypes.oneOf(['nav', 'main', 'section', 'div']),

        /** If true, a select dropdown and button will be added to this component.  */
        hasSelectElem: PropTypes.bool,

        /** Set an ID for the select component */
        selectID: PropTypes.string,

        /** Set a label for the select component */
        selectLabel: PropTypes.string,

        /** Set placeholder text the select component */
        selectPlaceholder: PropTypes.string,

        /** Set the button text for the select component */
        selectButtonText: PropTypes.string,

        /** Set the button onClick handler for the select component */
        selectButtonOnClick: PropTypes.func,

        /** Set the dropdown menu options for the select component */
        selectOptions: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string
        }))
    };

    static defaultProps = {
        hasButton: false,
        isScroll: false,
        text: '',
        semanticElementName: 'section',
        hasSelectElem: false,
        hasDarkText: false
    };

    goTo(id) {
        document.getElementById(id).scrollIntoView({ 'behavior': 'smooth', 'block': 'start' });
    }

    handleSelectButtonClick = () => {
        const selectOptionsIndex = this.selectRef.selectedIndex - 1;

        if (selectOptionsIndex >= 0) {
            this.props.selectButtonOnClick(this.props.selectOptions[selectOptionsIndex]);
        }
    }

    heroClick = () => {
        this.props.history.push(`${this.props.buttonLink}`);
    }

    heroScroll = () => {
        this.goTo(`${this.props.buttonLink}`);
    }

    heroButton = () => {
        return (
            <React.Fragment>
                <Button
                    appearance={this.props.buttonAppearance}
                    size="lg"
                    className="mt-3"
                    onClick={this.props.isScroll ? this.heroScroll : this.heroClick}>
                    {this.props.buttonText}
                </Button>
            </React.Fragment>
        )
    }

    selectButton = () => {
        return (
            <Button
                appearance={this.props.buttonAppearance}
                size="lg"
                className="hero-select-button"
                onClick={this.handleSelectButtonClick}>
                {this.props.selectButtonText}
            </Button>
        )
    }

    render() {
        const longHeroTitle = this.props.title.length <= 30 ? "" : "rec-long-hero-title";
        const SemanticElementName = this.props.semanticElementName;
        const hasDarkText = this.props.hasDarkText ? "has-dark-text" : "";
        const removeBackgroundGradient = this.props.hasDarkText ? "no-background-gradient" : "";

        let showSelectElem = null;
            if (this.props.hasSelectElem) {
                showSelectElem = (
                    <Select
                        id={this.props.selectID}
                        label={this.props.selectLabel}
                        placeholder={this.props.selectPlaceholder}
                        options={this.props.selectOptions}
                        innerRef={(ref) => this.selectRef = ref}
                        isLabelVisible={false}
                        isInline /> );
        }

        return (
            <SemanticElementName className={`rec-section-hero-full-width-wrap ${this.props.className} ${removeBackgroundGradient}`}>
                <div className="rec-section-hero-body-outer-wrap">
                    <div className="rec-section-hero-body">
                        <Heading headingLevel={1} appearance="h1" className={`rec-section-hero-title ${longHeroTitle} ${hasDarkText}`}>
                            {this.props.title}
                        </Heading>

                        {
                            this.props.text.length > 0 &&
                            <p className={`rec-section-hero-text ${hasDarkText}`}>
                                {this.props.text}
                            </p>
                        }

                        {
                            this.props.hasSelectElem && (
                                <div className="rec-section-hero-select-wrap">
                                    {showSelectElem}
                                    {this.props.hasSelectElem ? this.selectButton(): ''}
                                </div>
                            )
                        }
                        {this.props.hasButton ? this.heroButton(): ''}
                    </div>
                </div>
            </SemanticElementName>
        );
    }
}

